'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    InputText: ()=>InputText_InputText
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const field_namespaceObject = require("@base-ui-components/react/field");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const external_InputTextWrapper_cjs_namespaceObject = require("./InputTextWrapper.cjs");
const utils_cjs_namespaceObject = require("../Tooltip/utils.cjs");
const external_InputText_variants_cjs_namespaceObject = require("./InputText.variants.cjs");
const InputText_InputText = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ label, isLabelHidden, helperText, errorText, maxLength, iconLeft, iconRight, emphasis, isInset, size, className, isDisabled, errorMessage, validate, 'aria-invalid': ariaInvalid, validationMode = 'onBlur', onChange, hasExternalError = false, ...props }, ref) {
    const { name, ...rest } = props;
    const [internalError, setInternalError] = (0, external_react_namespaceObject.useState)(false);
    const [success, setSuccess] = (0, external_react_namespaceObject.useState)(false);
    const tooltipSideOffset = (0, utils_cjs_namespaceObject.getTooltipSideOffset)(size);
    const hasPlaceholder = Boolean(props.placeholder);
    const hasErrorTextOverride = Boolean(errorText);
    const hasError = hasErrorTextOverride || hasExternalError || internalError;
    const styles = (0, external_InputText_variants_cjs_namespaceObject.inputTextVariants)({
        emphasis,
        isDisabled,
        hasIconLeft: !!iconLeft,
        hasIconRight: !!iconRight,
        isInset,
        hasPlaceholder,
        size,
        error: hasError,
        success: success && !hasError
    });
    function handleChange(event) {
        onChange?.(event);
    }
    const handleValidation = (value)=>{
        if (!hasErrorTextOverride && !hasExternalError && validate && 'string' == typeof value) {
            const isValid = validate(value);
            setInternalError(!isValid);
            setSuccess(isValid);
        }
        return null;
    };
    const getDisplayErrorText = ()=>{
        if (errorText) return errorText;
        if (!errorText && errorMessage && (hasExternalError || internalError)) return errorMessage;
    };
    const displayErrorText = getDisplayErrorText();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(field_namespaceObject.Field.Root, {
        name: name,
        className: (0, cn_cjs_namespaceObject.cn)(styles.root(), className),
        validate: handleValidation,
        disabled: isDisabled,
        validationMode: validationMode,
        children: [
            label ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(field_namespaceObject.Field.Label, {
                className: (0, cn_cjs_namespaceObject.cn)(styles.labelSlot(), isLabelHidden ? 'hidden' : ''),
                children: label
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(field_namespaceObject.Field.Control, {
                render: (inputProps)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_InputTextWrapper_cjs_namespaceObject.InputTextWrapper, {
                        ...inputProps,
                        ...rest,
                        ref: ref,
                        styles: styles,
                        iconLeft: iconLeft,
                        ariaInvalid: Boolean(ariaInvalid) || hasError,
                        errorText: displayErrorText,
                        maxLength: maxLength,
                        onChange: handleChange,
                        error: hasError,
                        tooltipSideOffset: tooltipSideOffset,
                        errorMessage: errorMessage,
                        success: success && !hasError,
                        iconRight: iconRight
                    })
            }),
            helperText || displayErrorText || maxLength ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: styles.textSlot(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(field_namespaceObject.Field.Error, {
                        match: Boolean(displayErrorText) && !errorMessage,
                        className: styles.errorTextSlot(),
                        "aria-live": "assertive",
                        children: displayErrorText
                    }),
                    !displayErrorText && helperText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(field_namespaceObject.Field.Description, {
                        className: styles.helperTextSlot(),
                        "aria-live": "polite",
                        children: helperText
                    }) : null,
                    maxLength && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: styles.characterCount(),
                        children: [
                            "0/",
                            maxLength
                        ]
                    })
                ]
            }) : null
        ]
    });
});
exports.InputText = __webpack_exports__.InputText;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "InputText"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
